import Component from '@glimmer/component';
export default class PlayerWideComponent extends Component {}
